import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ICONS } from '../../../../constants';
import Theme from '../../../../theme';

const StyledSvg = styled.svg`
	display: inline-block;
	vertical-align: middle;

	${(props) => (props.color && ICONS[props.use].format === 'data') && `
		path {
			opacity: ${props.disabled ? '0.5' : '1'}
			fill: ${Theme[props.color] || props.color};
		}
	`};
`;

const Icon = ({ size = 1, ...props }) => {
	if( !Object.prototype.hasOwnProperty.call(ICONS, props.use) ) {
		return null;
	}

	const useIcon = ICONS[props.use];

	const content = useIcon.format === 'data'
		? <path d={useIcon.path} />
		: useIcon.markup;

	return (
		<StyledSvg
			width={`${size}rem`}
			height={`${size}rem`}
			viewBox={useIcon.viewBox}
			{...props}
		>
			{content}
		</StyledSvg>
	);
};

Icon.propTypes = {
	use: PropTypes.string.isRequired,
	size: PropTypes.number,
	color: PropTypes.string
};

export default Icon;
